// SEO landing pages per fornitore (Google Ads, Meta, AWS, Zoom, Hetzner).
// Ogni entry alimenta /autofattura/:slug tramite SupplierLanding.jsx.

export const SUPPLIER_LANDINGS = [
  {
    slug: "google-ads",
    supplier: {
      name: "Google Ireland Ltd",
      brand: "Google Ads",
      vatId: "IE6388047V",
      address: "Gordon House, Barrow Street, Dublin 4, Ireland",
      country: "IE",
      logoSlug: "google", // Simple Icons
      brandColor: "#4285F4",
    },
    hero: {
      kicker: "Autofattura estera · TD17",
      h1: "Autofattura per Google Ads",
      h1Suffix: "in 30 secondi",
      subtitle:
        "Carica il PDF di Google Ireland, l'AI estrae fornitore, VAT ID e importo, genera XML FatturaPA conforme SDI 1.2.2 con reverse charge 22% e codice TD17. Anche in regime forfettario.",
      benefits: [
        "TD17 e reverse charge 22% preimpostati",
        "VAT IE6388047V validato con VIES",
        "Invio SDI diretto o via Fatture in Cloud",
        "Compatibile con regime forfettario RF19",
      ],
    },
    problem: {
      title: "Il problema di ogni mese",
      body: "Google Ireland ti manda la fattura senza IVA italiana. Se hai P.IVA italiana devi generare un'autofattura con codice TD17, aliquota 22% in reverse charge e trasmetterla allo SDI entro il 16 del mese successivo. Farlo a mano richiede 15-20 minuti per fattura. Sbagliare significa rischiare sanzioni fino al 100% dell'IVA non versata.",
    },
    steps: [
      { title: "Scarica il PDF Google", body: "Da payments.google.com nella sezione Fatture, scarica il PDF mensile di Google Ireland." },
      { title: "Trascinalo su Autofattura", body: "L'AI Gemini legge fornitore (Google Ireland Ltd), VAT (IE6388047V), imponibile, valuta e data in 12 secondi." },
      { title: "Conferma e invia", body: "TD17 e reverse charge 22% sono già impostati per la tua P.IVA. Un click e l'XML parte allo SDI, riceverai la RC (consegna) entro 30 minuti." },
    ],
    example: {
      supplier: "Google Ireland Ltd",
      vatId: "IE6388047V",
      logo: "G",
      invoiceNr: "5289301923",
      date: "31/01/2026",
      imponibile: "€ 1.243,56",
      iva: "€ 273,58",
      td: "TD17 · Servizi UE",
    },
    facts: [
      { label: "Tempo per una autofattura Google", value: "12 s" },
      { label: "Aliquota reverse charge", value: "22 %" },
      { label: "Codice tipo documento", value: "TD17" },
      { label: "Codice destinatario SDI", value: "0000000" },
    ],
    faq: [
      { q: "Devo emettere autofattura per ogni fattura Google Ads?",
        a: "Sì, una per ciascuna fattura mensile ricevuta da Google Ireland. Tipicamente 12 all'anno." },
      { q: "Se sono in regime forfettario posso saltarla?",
        a: "No. Il forfettario è obbligato all'autofattura estera. Devi versare il 22% dell'IVA con F24 entro il 16 del mese successivo." },
      { q: "Quanto costa il servizio?",
        a: "€14,90 per 25 autofatture (starter), €24,90 per 60 (business), €39,90 per 150 (pro). Nessun abbonamento. Al signup 5 crediti gratuiti." },
    ],
    relatedPostSlug: "come-fare-autofattura-google-ads-2026",
    seoDescription:
      "Autofattura Google Ads (Google Ireland) automatica con AI: TD17, reverse charge 22%, XML FatturaPA conforme SDI. Anche in regime forfettario. Prova gratis con 5 crediti.",
    seoKeywords: [
      "autofattura Google Ads", "TD17 Google", "Google Ireland VAT IE6388047V",
      "reverse charge Google Ads", "autofattura forfettario Google",
    ],
  },
  {
    slug: "meta-ads",
    supplier: {
      name: "Meta Platforms Ireland Ltd",
      brand: "Meta Ads",
      vatId: "IE9692928F",
      address: "4 Grand Canal Square, Grand Canal Harbour, Dublin 2, Ireland",
      country: "IE",
      logoSlug: "meta",
      brandColor: "#0866FF",
    },
    hero: {
      kicker: "Autofattura estera · TD17",
      h1: "Autofattura per Meta Ads",
      h1Suffix: "Facebook + Instagram",
      subtitle:
        "Le fatture di Meta Platforms Ireland per pubblicità Facebook, Instagram, Messenger e WhatsApp Business integrate allo SDI in un click, con TD17 e reverse charge 22%.",
      benefits: [
        "VAT IE9692928F preconfigurato",
        "Copre Facebook + Instagram + Messenger + WhatsApp",
        "Codice TD17 e Natura N6.9 automatici",
        "Inbound email dedicata per raccolta automatica",
      ],
    },
    problem: {
      title: "Il paradosso Meta",
      body: "Se hai un solo account pubblicitario, Meta emette 1 fattura al mese che aggrega Facebook, Instagram, Messenger e (se attivo) WhatsApp Business. Anche una sola voce non integrata allo SDI genera un'anomalia rilevabile dai controlli incrociati AdE. Il problema è il costo del tempo per farla a mano.",
    },
    steps: [
      { title: "Configura l'inbound email", body: "Ricevi un indirizzo dedicato. Su Gmail imposti una regola per inoltrare le email Meta \"L'estratto conto di [account] è pronto\"." },
      { title: "Meta invia, il sistema legge", body: "Il PDF viene estratto automaticamente. VAT IE9692928F, imponibile e data caricati in dashboard senza tocco umano." },
      { title: "Conferma e trasmetti", body: "TD17 + N6.9 pronti. Trasmetti allo SDI. Il ciclo Meta-Ads → autofattura → SDI diventa completamente autonomo." },
    ],
    example: {
      supplier: "Meta Platforms Ireland",
      vatId: "IE9692928F",
      logo: "M",
      invoiceNr: "PIN-3388-1902",
      date: "31/01/2026",
      imponibile: "€ 892,10",
      iva: "€ 196,26",
      td: "TD17 · Servizi UE",
    },
    facts: [
      { label: "VAT Meta Platforms Ireland", value: "IE9692928F" },
      { label: "Aliquota reverse charge", value: "22 %" },
      { label: "Codice tipo documento", value: "TD17" },
      { label: "Natura IVA", value: "N6.9" },
    ],
    faq: [
      { q: "Come faccio a inoltrare automaticamente le email di Meta?",
        a: "Su Gmail: Impostazioni → Filtri → \"Crea filtro\" → mittente \"noreply-ads@fb.com\" → \"Inoltra a...\" al tuo indirizzo autofattura.dasabo.com. Setup una tantum." },
      { q: "Devo fare una autofattura per Facebook e una per Instagram?",
        a: "No. Se hai un unico account pubblicitario Meta, riceverai 1 fattura al mese che comprende tutto e richiede 1 sola autofattura." },
      { q: "E WhatsApp Business API?",
        a: "Stesso trattamento: fornitore Meta Platforms Ireland, TD17, reverse charge 22%." },
    ],
    relatedPostSlug: "autofattura-meta-ads-facebook-instagram",
    seoDescription:
      "Autofattura per Meta Ads (Facebook, Instagram, WhatsApp Business) automatica: TD17, reverse charge 22%, VAT IE9692928F. Elaborazione batch e inbound email per freelance italiani.",
    seoKeywords: [
      "autofattura Meta Ads", "autofattura Facebook Ads", "autofattura Instagram Ads",
      "Meta Platforms Ireland VAT", "TD17 Facebook",
    ],
  },
  {
    slug: "amazon-aws",
    supplier: {
      name: "Amazon Web Services EMEA SARL",
      brand: "AWS",
      vatId: "LU26375245",
      address: "38 avenue John F. Kennedy, L-1855 Luxembourg",
      country: "LU",
      logoSlug: "amazonwebservices",
      brandColor: "#FF9900",
    },
    hero: {
      kicker: "Autofattura estera · TD17",
      h1: "Autofattura per Amazon Web Services",
      h1Suffix: "EMEA Lussemburgo",
      subtitle:
        "AWS fattura da Lussemburgo con VAT LU26375245. Automatizza le autofatture TD17 mensili con reverse charge 22% direttamente dalle fatture in EUR o multi-currency.",
      benefits: [
        "Multi-valuta con FX rate Banca d'Italia",
        "Aggregazione automatica per account AWS",
        "VAT LU26375245 preconfigurato",
        "Codice TD17 per tutti i servizi cloud",
      ],
    },
    problem: {
      title: "Il problema di chi usa il cloud",
      body: "Se hai anche solo 3-4 servizi AWS attivi (S3, EC2, RDS) ricevi 1 fattura al mese in EUR o USD. Se sono in USD, va convertita al tasso Banca d'Italia della data fattura. Farlo a mano ogni mese è tedioso e prono a errori di arrotondamento — spesso causa di scarto SDI.",
    },
    steps: [
      { title: "Scarica il PDF AWS", body: "Da console.aws.amazon.com → Billing → Bills. Il PDF include tutte le voci del mese aggregate." },
      { title: "L'AI gestisce il multi-valuta", body: "Se in USD, il sistema applica automaticamente il tasso BdI del giorno emissione e riscala imponibile e IVA in EUR." },
      { title: "Conferma e invia", body: "TD17 preimpostato, reverse charge 22% calcolato in EUR, XML validato. Un click e va allo SDI." },
    ],
    example: {
      supplier: "Amazon Web Services EMEA",
      vatId: "LU26375245",
      logo: "A",
      invoiceNr: "EU-INV-8837211",
      date: "01/02/2026",
      imponibile: "€ 428,90",
      iva: "€ 94,36",
      td: "TD17 · Servizi UE",
    },
    facts: [
      { label: "VAT AWS EMEA Lussemburgo", value: "LU26375245" },
      { label: "Multi-currency support", value: "USD, EUR, GBP" },
      { label: "Codice tipo documento", value: "TD17" },
      { label: "FX source", value: "Banca d'Italia" },
    ],
    faq: [
      { q: "Devo integrare anche la parte S3 mensile piccolissima?",
        a: "Sì. AWS emette 1 fattura al mese che include TUTTE le voci (anche €0.03 di S3). Ne fai una sola autofattura." },
      { q: "E se pago AWS in USD?",
        a: "Il tasso di cambio da applicare è quello del giorno di emissione fattura (fonte ufficiale: BdI/BCE). Il nostro sistema lo scarica automaticamente e riscala imponibile e IVA." },
      { q: "AWS emette dall'Europa o dagli USA?",
        a: "Per clienti EU, l'entità fatturante è Amazon Web Services EMEA SARL (Lussemburgo). Solo alcuni servizi non-standard vengono fatturati da AWS Inc. (US) — in quel caso è ancora TD17, senza VAT ID." },
    ],
    relatedPostSlug: "saas-esteri-autofattura-guida-completa",
    seoDescription:
      "Autofattura per Amazon Web Services (AWS EMEA Lussemburgo): TD17, multi-valuta USD/EUR con tasso Banca d'Italia, reverse charge 22%. Automatica in 30 secondi.",
    seoKeywords: [
      "autofattura AWS", "AWS Amazon Web Services Lussemburgo", "TD17 AWS",
      "autofattura cloud", "reverse charge AWS",
    ],
  },
  {
    slug: "zoom",
    supplier: {
      name: "Zoom Video Communications Ireland Ltd",
      brand: "Zoom",
      vatId: "IE3384253BH",
      address: "70 Sir John Rogerson's Quay, Dublin 2, Ireland",
      country: "IE",
      logoSlug: "zoom",
      brandColor: "#2D8CFF",
    },
    hero: {
      kicker: "Autofattura estera · TD17",
      h1: "Autofattura per Zoom",
      h1Suffix: "abbonamenti mensili e annuali",
      subtitle:
        "Zoom fattura dall'Irlanda con VAT IE3384253BH. Automatizza la tua autofattura TD17 per abbonamenti Pro, Business o Enterprise, mensili o annuali.",
      benefits: [
        "Riconoscimento automatico Zoom Pro / Business / Enterprise",
        "VAT IE3384253BH validato",
        "Ricorrenza annuale gestita correttamente",
        "Reverse charge 22% preimpostato",
      ],
    },
    problem: {
      title: "Piccolo importo, obbligo pieno",
      body: "Un abbonamento Zoom Pro costa €149/anno o €13,99/mese. Basta una sola fattura non integrata a fine anno per creare un'anomalia nel VIES. E se sei in forfettario, quei €149 diventano €181 di costo reale (IVA da versare in F24).",
    },
    steps: [
      { title: "Scarica la ricevuta Zoom", body: "Da zoom.us/billing → Fatture. Il PDF è disponibile subito dopo il pagamento." },
      { title: "Carica su Autofattura", body: "L'AI legge fornitore Zoom Ireland, VAT, importo €. Data e periodo di abbonamento identificati automaticamente." },
      { title: "TD17 in un click", body: "Un click e la tua autofattura Zoom è nello SDI. Ricevi la RC entro 30 minuti." },
    ],
    example: {
      supplier: "Zoom Video Communications Ireland",
      vatId: "IE3384253BH",
      logo: "Z",
      invoiceNr: "INV-ZM-887321",
      date: "15/01/2026",
      imponibile: "€ 149,00",
      iva: "€ 32,78",
      td: "TD17 · Servizi UE",
    },
    facts: [
      { label: "VAT Zoom Ireland", value: "IE3384253BH" },
      { label: "Ricorrenza tipica", value: "mensile o annuale" },
      { label: "Codice tipo documento", value: "TD17" },
      { label: "Costo per autofattura Zoom", value: "€ 0,60" },
    ],
    faq: [
      { q: "L'abbonamento annuale Zoom vale come 12 fatture?",
        a: "No, è 1 sola fattura annuale. Fai 1 autofattura all'anno." },
      { q: "E le licenze aggiuntive comprate a metà anno?",
        a: "Zoom emette una fattura pro-rata al momento dell'attivazione. Ciascuna richiede la sua autofattura." },
    ],
    relatedPostSlug: "saas-esteri-autofattura-guida-completa",
    seoDescription:
      "Autofattura per Zoom Video Communications Ireland (VAT IE3384253BH): TD17, reverse charge 22%. Abbonamenti Pro, Business, Enterprise. Automatica in 30 secondi.",
    seoKeywords: [
      "autofattura Zoom", "Zoom Ireland VAT", "TD17 Zoom",
      "autofattura SaaS Zoom", "reverse charge Zoom Pro",
    ],
  },
  {
    slug: "hetzner",
    supplier: {
      name: "Hetzner Online GmbH",
      brand: "Hetzner",
      vatId: "DE812871812",
      address: "Industriestr. 25, 91710 Gunzenhausen, Germany",
      country: "DE",
      logoSlug: "hetzner",
      brandColor: "#D50C2D",
    },
    hero: {
      kicker: "Autofattura estera · TD17",
      h1: "Autofattura per Hetzner",
      h1Suffix: "hosting e cloud tedesco",
      subtitle:
        "Hetzner Online GmbH emette dalla Germania con VAT DE812871812. Server, cloud, dedicated e storage box: tutte le tue fatture Hetzner in autofatture TD17 automatiche.",
      benefits: [
        "VAT DE812871812 preconfigurato",
        "Aggregazione automatica multi-servizio",
        "Codice TD17 anche per hosting/cloud",
        "Integrazione con inbound email Hetzner",
      ],
    },
    problem: {
      title: "Chi ha 2-3 server Hetzner sa",
      body: "Hetzner ti emette 1 fattura al mese per progetto/servizio. Se hai un dedicated + due cloud instances + una storage box, sono 4 fatture da integrare, ognuna con la sua data e importo. Farlo a mano ogni mese equivale a mezza giornata all'anno buttata via.",
    },
    steps: [
      { title: "Configura inbound email Hetzner", body: "Sul tuo account Hetzner Robot inserisci il tuo indirizzo dedicato di autofattura come CC/destinatario. Le fatture arrivano automaticamente." },
      { title: "Estrazione multi-fattura", body: "Il sistema riconosce ogni fattura Hetzner separatamente, con la sua data e progetto. Dashboard con overview mensile." },
      { title: "Trasmissione batch", body: "Conferma in blocco tutte le fatture Hetzner del mese. TD17 automatico. Un click e vanno tutte allo SDI." },
    ],
    example: {
      supplier: "Hetzner Online GmbH",
      vatId: "DE812871812",
      logo: "H",
      invoiceNr: "IN-2026-0128-1188221",
      date: "31/01/2026",
      imponibile: "€ 89,50",
      iva: "€ 19,69",
      td: "TD17 · Servizi UE",
    },
    facts: [
      { label: "VAT Hetzner Online GmbH", value: "DE812871812" },
      { label: "Paese", value: "Germania (DE)" },
      { label: "Codice tipo documento", value: "TD17" },
      { label: "Servizi coperti", value: "Dedicated, Cloud, Storage" },
    ],
    faq: [
      { q: "Hetzner ha VAT tedesca — è comunque TD17?",
        a: "Sì. TD17 vale per tutti i servizi da fornitore estero (UE o extra-UE). TD18 vale solo per beni fisici intracomunitari — non è il caso dell'hosting." },
      { q: "Le fatture Hetzner sono in EUR o USD?",
        a: "Sempre in EUR (Hetzner è tedesco). Nessun problema di FX rate." },
    ],
    relatedPostSlug: "saas-esteri-autofattura-guida-completa",
    seoDescription:
      "Autofattura per Hetzner Online GmbH (VAT DE812871812): TD17, reverse charge 22%. Dedicated, Cloud, Storage. Elaborazione batch e inbound email per DevOps italiani.",
    seoKeywords: [
      "autofattura Hetzner", "Hetzner Germania VAT", "TD17 Hetzner",
      "autofattura hosting", "reverse charge Hetzner cloud",
    ],
  },
];

export function getSupplierBySlug(slug) {
  return SUPPLIER_LANDINGS.find((s) => s.slug === slug) || null;
}
